import {RouteConfig} from "@lit-labs/router";
import {html} from "lit";
import {customElement} from "lit/decorators/custom-element.js";
import {state} from "lit/decorators/state.js";
import {container} from "tsyringe";
import {IssueHelper} from "../../domain/helpers/issue.helper";
import {IssueRepository} from "../../domain/repositories/issue.repository";
import {StringHelper} from "../../helpers/string.helper";
import {AbstractLitElement} from "../abstract-lit.element";

type Action = { name: string, params: any };

@customElement(`ha-quicklink`)
export class HaQuickLinkComponent extends AbstractLitElement {

    @state()
    private _action: Action | null = null;

    // Lifecycle-Callback, der aufgerufen wird, wenn die Route zur Komponente navigiert
    // noinspection JSUnusedGlobalSymbols
    public onBeforeEnter(location: any): void {
        const {meta} = location.route as RouteConfig & { meta: { action: string } };
        this._action = {
            name: meta.action,
            params: location.params
        }
    }

    // noinspection JSUnusedGlobalSymbols
    protected async _openIssueDialogAction({issue}: { issue: string }): Promise<void> {
        const issueEntity = await container.resolve(IssueRepository).findOneById(issue.toLowerCase());
        if (!issueEntity) {
            return;
        }

        IssueHelper.openIssuesEditDialog([issueEntity], issueEntity);
    }

    protected render(): unknown {
        return html``;
    }

    protected willUpdate() {
        if (!this._action) {
            return;
        }

        const actionMethodName = `_${StringHelper.toLowerCamelCase(this._action?.name)}Action`;
        // @ts-ignore
        this[actionMethodName](this._action.params).then();
    }

}